<template>
   <b-row
    class="dhn-breadcrumb"
   >
      <b-col
        class="shadow-sm py-3"
      >
        <b-link
          v-for="(link, index) in pathToPage"
          :key="index"
          router-tag="a"
          :to="{path: link.slug}"
          :disabled="link.disabled"
        >
          <span
            v-if="index > 0"
          >
            /
          </span>
          {{ link.name }}
        </b-link>
      </b-col>
   </b-row>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    pathToPage: Array
  },
  name: 'breadcrumb',
  data () {
    return {

    }
  },
  components: {

  },
  computed: {
    ...mapGetters({
      staticData: 'getStaticData',
      lang: 'getLanguage'
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
